export default "__VITE_ASSET__klBXPTHK__"